module.exports = "//d274d294w9cx2v.cloudfront.net/eea6446b780a218646c98e7e9a25bbb54cb4534b/images/venmoBadge.png";